export default __webpack_public_path__ + "static/media/left-dark.17c63e7a.svg";